import { HeadingLevel } from "@viagogo/core/ui";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import { useAppContext } from "src/shared/context/AppContext";
import { MarketplaceDisclosure } from "src/website-apps/shared/components/disclosures";
import { ErrorMessage } from "src/website-apps/shared/components/ErrorMessage";
import { createBrowseHeaderWithExperiment } from "src/website-apps/shared/components/header/BrowseHeaderWithExperiment";

const FindHeader = createBrowseHeaderWithExperiment(FeatureSetEnum.TMEnsembleAppNavHeaderDiscovery);

/**
 * Header portion of the Layout component on Find
 */
export const FindLayoutHeader = ({ model, setMobileMenuOpen, mobileMenuOpen }) => {
  const appContext = useAppContext();
  const { header, marketplaceDisclosure, sellSearch } = model;
  const showMarketplaceDisclosure = !sellSearch && !!marketplaceDisclosure;

  return (
    <HeadingLevel>
      <ErrorMessage />
      {showMarketplaceDisclosure && <MarketplaceDisclosure marketplaceDisclosureSiteMessage={marketplaceDisclosure} />}
      <FindHeader
        browseHeader
        bigPerformerBanner={false}
        disclaimerSameBackgroundAsHeader
        mobileMenuOpen={mobileMenuOpen}
        discoveryLinks={sellSearch ? null : header?.navigationBarLinks}
        isUserLoggedIn={appContext.isUserLoggedIn}
        onMobileMenuToggle={setMobileMenuOpen}
      />
    </HeadingLevel>
  );
};
